<div style="margin-right: 3px; margin-bottom: 10px; padding: 4px; border-radius: var(--border-radius);" [style.backgroundColor]="getBackgroundColor(note)" [style.color]="getTextColor(note)" data-cy="tdo-note-container">
  <div class="tdo-notes-content" data-cy="tdo-note-content">

    <textarea matInput
      #noteArea
      cdkTextareaAutosize
      #autosize="cdkTextareaAutosize"
      cdkAutosizeMinRows="2"
      cdkAutosizeMaxRows="50"
      [disabled]="isReadOnly"
      [(ngModel)]="note.Note"
      (appInputFinished)="onNoteInput($event, note)"
      (blur)="onNoteBlur($event, note)"
      (keydown)="onKeyDown($event)"
      [delayMs]="autoSaveMsDelay"
    data-cy="tdo-note-textarea"></textarea>

  </div>
  <div style="width: 100%; display: flex; position: relative; overflow-y: visible; max-height: 10px;" data-cy="tdo-note-lock-controls">
    <div style="flex: 1; display: flex;flex-flow: row; gap: 5px;">
      @if (isNoteLocked(note)) {
        <lucide-icon name="lock" [size]="20" [class.disabled]="isUnlockDisabled(note)"
          (click)="isUnlockDisabled(note) ? null : unlockNote()"
          [style.color]="isUnlockDisabled(note) ? 'var(--tdo-disabled-color, #ccc)' : 'var(--tdo-secondary-accent)'"
          [style.cursor]="isUnlockDisabled(note) ? 'not-allowed' : 'default'"
          [matTooltip]="isUnlockDisabled(note) ? 'Note cannot be unlocked (created more than 24 hours ago)' : 'Note locked - click to unlock'"
        data-cy="tdo-note-lock-icon"></lucide-icon>
      }
      @if (!isNoteLocked(note)) {
        <lucide-icon name="unlock" [size]="20" (click)="lockNote()" style="color: var(--tdo-secondary-accent); cursor: default;" matTooltip="Note unlocked - click to lock" data-cy="tdo-note-unlock-icon"></lucide-icon>
      }
      @if (storedNoteFilterSettings.isHideExtraInfo) {
        <div class="tdo-note-category-pill" style="flex: 1;" data-cy="tdo-note-categories-list">
          @for (category of note.dataNoteCategories; track category.enumNoteCategoryID) {
            <div data-cy="tdo-note-category-item">
              {{category.enumNoteCategory.ItemDisplayValue}}
            </div>
          }
        </div>
      }
    </div>
    <div (click)="openNoteDialog()" style="color: var(--tdo-secondary); cursor: pointer; transform: scale(0.9, 0.9); height: min-content; width: min-content; position: relative; top: -2px;" matTooltip="Open note in dialog." data-cy="tdo-note-dialog-button"><lucide-icon name="external-link" [size]="20"></lucide-icon></div>
  </div>
  @if (!storedNoteFilterSettings.isHideExtraInfo) {
  <div style="margin-top: 8px; line-height: 2; padding: 3px;" data-cy="tdo-note-metadata">
    @if (!storedNoteFilterSettings.isCondensedView) {
      <div class="tdo-note-info" style="position: relative;" data-cy="tdo-note-categories-section">
        <span class="tdo-note-info-item" style="flex-basis: 70px;" data-cy="tdo-note-categories-label">Categories</span>
        <div class="tdo-note-category-pill" style="flex: 1;" data-cy="tdo-note-categories-list">
          @for (category of note.dataNoteCategories; track category.enumNoteCategoryID) {
            <div data-cy="tdo-note-category-item">
              {{category.enumNoteCategory.ItemDisplayValue}}
            </div>
          }
        </div>
        @if (!isLastItem && !isNoteLocked(note) && isUserHasRoleToEdit()) {
          <app-tdo-notes-multiselect-menu [isShowAllSelectors]="false" tooltip="Categories" type="category" [noteId]="note.NoteId" [selectableItems]="notesCategories" [categoryValues]="note.dataNoteCategories" (categorySelectionComplete)="onCategoryDropdownSelectionComplete($event, note)" [dropdownMenuYOffset]="-10" style="height: 20px; position: absolute; right: 0;" data-cy="tdo-note-categories-menu-not-last"></app-tdo-notes-multiselect-menu>
        }
        @if (isLastItem && !isNoteLocked(note) && isUserHasRoleToEdit()) {
          <app-tdo-notes-multiselect-menu [isShowAllSelectors]="false" tooltip="Categories" type="category" [noteId]="note.NoteId" [selectableItems]="notesCategories" [categoryValues]="note.dataNoteCategories" (categorySelectionComplete)="onCategoryDropdownSelectionComplete($event, note)" [dropdownMenuYOffset]="-50" style="height: 20px; position: absolute; right: 0;" data-cy="tdo-note-categories-menu-last"></app-tdo-notes-multiselect-menu>
        }
      </div>
    }
    @if (!storedNoteFilterSettings.isCondensedView) {
      <div class="tdo-note-info" style="position: relative;" data-cy="tdo-note-types-section">
        <span class="tdo-note-info-item" style="flex-basis: 70px;" data-cy="tdo-note-types-label">Types</span>
        <div class="tdo-note-type-pill" style="flex: 1;" data-cy="tdo-note-types-list">
          @for (type of note.dataNoteTypes; track type.enumNoteTypeID) {
            <div data-cy="tdo-note-type-item">
              {{type.enumNoteType?.ItemDisplayValue}}
            </div>
          }
        </div>
        @if (!isLastItem && !isNoteLocked(note) && isUserHasRoleToEdit()) {
          <app-tdo-notes-multiselect-menu [isShowAllSelectors]="false" tooltip="Types" type="type" [noteId]="note.NoteId" [selectableItems]="notesTypes" [typeValues]="note.dataNoteTypes" (typeSelectionComplete)="onTypeDropdownSelectionComplete($event, note)" [dropdownMenuYOffset]="-10" style="height: 20px; position: absolute; right: 0;" data-cy="tdo-note-types-menu-not-last"></app-tdo-notes-multiselect-menu>
        }
        @if (isLastItem && !isNoteLocked(note) && isUserHasRoleToEdit()) {
          <app-tdo-notes-multiselect-menu [isShowAllSelectors]="false" tooltip="Types" type="type" [noteId]="note.NoteId" [selectableItems]="notesTypes" [typeValues]="note.dataNoteTypes" (typeSelectionComplete)="onTypeDropdownSelectionComplete($event, note)" [dropdownMenuYOffset]="-50" style="height: 20px; position: absolute; right: 0;" data-cy="tdo-note-types-menu-last"></app-tdo-notes-multiselect-menu>
        }
      </div>
    }
    @if (storedNoteFilterSettings.isShowCreatedOn) {
      <div style="font-size: 12px;" data-cy="tdo-note-created-on">Created On <span style="font-weight: bold;" data-cy="tdo-note-created-on-value">{{getDate(note.xauditCreatedOn)}}</span></div>
    }
    @if (storedNoteFilterSettings.isShowCreatedBy) {
      <div style="font-size: 12px;" data-cy="tdo-note-created-by">Created By <span style="font-weight: bold;" data-cy="tdo-note-created-by-value">{{note.xauditCreatedByUser?.FirstName}} {{note.xauditCreatedByUser?.LastName}}</span></div>
    }
    @if (storedNoteFilterSettings.isShowModifiedOn) {
      <div style="font-size: 12px;" data-cy="tdo-note-modified-on">Modified On <span style="font-weight: bold;" data-cy="tdo-note-modified-on-value">{{getDate(note.xauditModifiedOn)}}</span></div>
    }
    @if (storedNoteFilterSettings.isShowModifiedBy) {
      <div style="font-size: 12px;" data-cy="tdo-note-modified-by">Modified By <span style="font-weight: bold;" data-cy="tdo-note-modified-by-value">{{note.xauditModifiedByUser?.FirstName}} {{note.xauditModifiedByUser?.LastName}}</span></div>
    }
  </div>
  }
  <div style="display: flex; width: fit-content; color: var(--tdo-primary-accent); margin-top: 8px;" data-cy="tdo-note-actions">
    @if (!isNoteLocked(note) && isUserHasRoleToEdit()) {
      <lucide-icon name="message-square" [size]="20" style="flex: 1; cursor: pointer; margin-right: 10px;" matTooltip="Note Builder" (click)="openNoteBuilder(note)" data-cy="tdo-note-builder-button"></lucide-icon>
    }
    @if (!isNoteLocked(note) && isUserHasRoleToEdit()) {
      <lucide-icon name="git-branch" [size]="20" style="flex: 1; cursor: pointer;" matTooltip="Macro Notes" (click)="openMacroNotes(note)" data-cy="tdo-note-macro-button"></lucide-icon>
    }
    @if (!isNoteLocked(note) && isUserHasRoleToEdit()) {
      <lucide-icon name="trash-2" [size]="20" style="flex: 1; cursor: pointer;" matTooltip="Delete Note" (click)="deleteNote()" data-cy="tdo-note-delete-button"></lucide-icon>
    }
  </div>
</div>
